import { createFileRoute, Outlet } from "@tanstack/react-router";
import i18n from "i18next";
import { ProjectProvider } from "~/contexts/ProjectContext";

export const Route = createFileRoute("/_app/projects/$projectId")({
  head: () => ({ meta: [{ title: i18n.t("general:documentTitle.project") }] }),
  component: ProjectRoute,
});

function ProjectRoute() {
  const { projectId } = Route.useParams();

  return (
    <ProjectProvider id={projectId}>
      <Outlet />
    </ProjectProvider>
  );
}
